import { all, fork } from 'redux-saga/effects'

import watchReportSaga from 'store/sagas/reportSaga'
import watchClapiSaga from 'store/sagas/clapiSaga'
import watchSearchSaga from 'store/sagas/searchSaga'
import watchLeadgenSaga from 'store/sagas/leadgenSaga'

function * rootSaga() {
  yield all([
    watchReportSaga,
    watchClapiSaga,
    watchSearchSaga,
    watchLeadgenSaga
  ].map(fork))
}

export default rootSaga
